import { TagApi } from '@movilizame/networking';

function convert (data) {
    let params = new window.URLSearchParams();
    for (let key in data) {
        params.append(key, data[key]);
    }
    return params;
}
export class AuthApi {

    constructor (net, list) {
        this.net = new TagApi(net, list);
    }

    /**
     *  Login user
     * @param {string} username
     * @param {string} password
     * @param {string} device_type
     * @param {string} app_version
     * @param {string} device_id
     */

    login (creds) {
        return this.net.post('/api/login', convert(creds));
    }

    /**
     *  Login user
     * @param {string} app_version
     */

    retoken (creds) {
        return this.net.post('/api/retoken', convert(creds));
    }

    /**
     * Registrar usuario
     *
     * @param {object} data
     */

    registrar (data) {
        return this.net.post('/api/registrar', data);
    }

    /**
     * Aceptar terminos y condiciones
     */

    acceptTerms () {
        return this.net.post('/api/acceptTerms', {});
    }

    /**
     * Reset de contraseña
     * @param {string} email
     */

    resetPassword (email) {
        return this.net.post('/api/reset', { email });
    }

    /**
     * Cerrar session
     */
    logoff (data = {}) {
        return this.net.post('/api/logoff', convert(data));
    }

    /**
     *  Update Device ID
     * @param {string} device_id
     * @param {string} app_version
     */

    updateDevice (data) {
        return this.net.post('/api/updateDevice', convert(data));
    }
};



// WEBPACK FOOTER //
// ./src/services/api/Auth.js